import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {EndpointService} from "./endpoint.service";
@Injectable({providedIn: 'root'})
export class UtilsService {
  constructor(private _http: HttpClient) { }

  getNthWorkingDay(n: number, date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const params = new HttpParams()
      .set('n', n.toString())
      .set('date', formattedDate);

    return this._http.get<any>(EndpointService.getNthWorkingDay, { params });
  }
}
